import React from 'react'
import { useTranslation } from 'react-i18next'

// Components
import Max2ContractHeadOfficeMinStay from './headoffice_minstay';
import Max2ContractHeadOfficeRelease from './headoffice_release';
import Max2ContractHeadOfficeMaxStay from './headoffice_maxstay';
import Max2ContractHeadOfficeArrivals from './headoffice_arrivals';
import Max2ContractHeadOfficeStopSales from './headoffice_stopsale';

// Semantic UI
import { Container, Header, HeaderContent, Icon } from 'semantic-ui-react';

// Styles
import './contract.css';



/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractHeadOffice = ({ editMode }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.headoffice.sections.minStay')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractHeadOfficeMinStay editMode={editMode} />
      </Container>

      <br />
      <br />

      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.headoffice.sections.release')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractHeadOfficeRelease editMode={editMode} />
      </Container>
      
      <br />
      <br />

      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.headoffice.sections.maxStay')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractHeadOfficeMaxStay editMode={editMode} />
      </Container>

      <br />
      <br />
      
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.headoffice.sections.arrivals')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractHeadOfficeArrivals editMode={editMode} />
      </Container>

      <br />
      <br />
      
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.headoffice.sections.stopSales')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractHeadOfficeStopSales editMode={editMode} />
      </Container>
    </>
  );
}

export default Max2ContractHeadOffice;
